if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"auth","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(35|496|673)|2(027|045|15|183|351|44|952)|5(109|115|433|463|552|705|989)|8(204|455|753)|9([34]15|439)|4479|4880|6085|6565|761)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}